<template>
  <div :id="idName" class="costLayout">
    <div id="sub-head" v-if="!(isH5 || hideSideMenu)">
      <div class="title">{{ $t('费用中心') }}</div>
      <es-menu :default-active="activeIndex" @select="selectMenu" class="es-menu-demo">
        <div v-for="(item, index) in navList" :key="index">
          <es-submenu v-if="item.children" :index="item.active">
            <span slot="title">
              <i :class="item.icon" class="show"></i>
              <i :class="item.icon + '-active'" class="hide"></i>
              {{ item.label }}
            </span>
            <es-menu-item v-for="childItem in item.children" :key="childItem.active" :index="childItem.active">
              {{ childItem.label }}
            </es-menu-item>
          </es-submenu>
          <es-menu-item v-else :index="item.active" @mouseover="selectStyle(item)">
            <span slot="title">
              <i :class="item.icon" class="show"></i>
              <i :class="item.icon + '-active'" class="hide"></i>
              {{ item.label }}</span
            >
          </es-menu-item>
        </div>
      </es-menu>
    </div>
    <div :class="className">
      <router-view class="router-body" :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { mapState } from 'vuex'
export default {
  components: {},
  computed: {
    ...mapState({
      isH5: state => state.isH5,
      hideSideMenu: state => state.hideSideMenu,
    }),
  },
  data() {
    return {
      activeIndex: '',
      idName: '',
      className: '',
      navList: [],
    }
  },
  mounted() {
    this.activeIndex = this.$route.meta.nav
    this.idName = this.isH5 ? 'h5Cost' : 'cost'
    this.className = this.isH5 ? 'h5main' : 'main'
    this.getShowNav()
  },
  watch: {
    $route(to, from) {
      this.activeIndex = this.$route.meta.nav
    },
  },
  methods: {
    selectMenu(index, indexPath) {
      this.$router.push(index)
    },

    async getShowNav() {
      const navList = []
      // 查询是否有返佣钱包
      navList.push({ active: 'MyWallet', label: $t('我的账户'), icon: 'wallet-icon' })
      navList.push({ active: 'MyOrder', label: $t('我的订单'), icon: 'order-icon' })
      navList.push({ active: 'MyBill', label: $t('我的账单'), icon: 'bill-icon' })
      this.navList = navList
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .es-submenu__title:hover,
.es-menu-item:hover {
  .show {
    display: none;
  }
  .hide {
    display: inline-block;
  }
}
/deep/ .is-active,
.es-menu-item.is-active {
  .show {
    display: none;
  }
  .hide {
    display: inline-block;
  }
  .es-submenu__icon-arrow {
    color: #0975e1 !important;
  }
}
.costLayout {
  display: flex;
  overflow-y: auto;
}
#sub-head {
  width: 190px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  flex: 0 0 auto;
  border-right: 1px solid #e4e4e4;
}
.main {
  display: flex;
  flex: 1 1 auto;
  overflow-y: auto;
}
#cost {
  width: 100%;
  flex: 1;
}
#h5Cost {
  height: 100%;
}
.h5main {
  height: 100%;
  width: 100%;
}
.title {
  width: 100%;
  height: 52px;
  line-height: 52px;
  padding-left: 20px;
  font-size: 16px;
  border-bottom: 1px solid #e4e4e4ff;
}
.router-body {
  width: 100%;
}
.main > .router-body {
  min-width: 1100px;
}
.order-icon {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/order.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}
.order-icon-active {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/orderActive.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}
.present-icon {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/present.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}
.present-icon-active {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/presentActive.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}
.wallet-icon {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/wallet.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}

.wallet-icon-active {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/walletActive.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}
.bill-icon {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/bill.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}
.bill-icon-active {
  width: 14px;
  height: 13px;
  display: inline-block;
  background: url('../assets/common/billActive.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  transition: 0.2s background;
}
.hide {
  display: none;
}
.es-menu {
  margin-bottom: 16px;
  .es-menu-item {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    padding: 0;
  }
}
.es-menu--horizontal > .es-menu-item.is-active {
  color: #1063f1;
  font-weight: 600;
  border-bottom: 3px solid #1063f1;
}
</style>
